// extracted by mini-css-extract-plugin
module.exports = {"stake":"StakeFilter_stake__3mBif","header":"StakeFilter_header__36p3K","radioGroup":"StakeFilter_radioGroup__39L0H","totals":"StakeFilter_totals__1Kdzm"};